"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var deepFreeze = require('deep-freeze');

var _default = deepFreeze({
  DOCKETS: {
    id: '8.1048576'
  },
  RESTRUCTURINGDB: {
    id: '8.2048',
    name: 'Restructuring Data',
    isLegacy: false
  }
});

exports["default"] = _default;